"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('tag');
const Tag = (props) => {
    const { color, plain, size, block, className, style, children, onTap } = props;
    const classes = classnames_1.default(prefixCls, {
        [`${prefixCls}-plain`]: plain,
        [`${prefixCls}-small`]: size === 'small',
        [`${prefixCls}-large`]: size === 'large',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-${color}`]: color,
    }, className);
    return (React.createElement(one_1.View, { className: classes, style: style, onTap: onTap }, children));
};
Tag.CheckableTag = (props) => {
    const { className, checked, checkedColor, style = {}, disabled, onChange, children } = props;
    const { height } = style;
    let tagHeight = height;
    if (typeof height === 'string') {
        if (height.includes('px')) {
            tagHeight = Number(height.slice(0, -2));
        }
        else {
            tagHeight = Number(height);
        }
    }
    let tagStyle = undefined;
    if (height) {
        tagStyle = Object.assign(Object.assign({}, style), { lineHeight: `${tagHeight - 4}px` });
    }
    const handleChange = () => {
        if (disabled) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    };
    return (React.createElement(Tag, Object.assign({ size: "large" }, props, { className: classnames_1.default({
            [`${prefixCls}-checkable`]: true,
            [`${prefixCls}-checked`]: checked,
            [`${prefixCls}-${checkedColor}`]: checked && checkedColor,
            [`${prefixCls}-disabled`]: disabled,
        }, className), style: tagStyle, onTap: handleChange }), children));
};
exports.default = Tag;
